import Bowser from 'bowser';

import { globalDeprecatedDefinition, browsersUpdateUrl } from './definitions';

const BrowserDetector = Bowser.getParser(window.navigator.userAgent);

const getBrowsers = () => {
    const preferredDefinition = typeof deprecatedDefinition !== 'undefined' ? deprecatedDefinition : [];

    return globalDeprecatedDefinition.map((item) => {
        const preferred = preferredDefinition.find(preffered => preffered.browser === item.browser);

        return {
            browser: item.browser,
            version: preferred?.version ?? item.version,
            url: browsersUpdateUrl[item.browser] ?? undefined,
        };
    });
};

const getSatisfiableVersions = () => {
    return getBrowsers()
        .reduce(
            (currentObject, item) => (
                {...currentObject, [item.browser]: item.version }
            ), {}
        );
};

const isValidBrowser = () => {
    return getBrowsers()
        .some((item) => BrowserDetector.is(item.browser, true))
            ? BrowserDetector.satisfies(getSatisfiableVersions())
            : true;
};

const unsupportedBrowserHandler = () => {
    if(isValidBrowser()) {
        return false;
    }

    const currentBrowser = getBrowsers().find((item) => BrowserDetector.is(item.browser, true));

    setTimeout(
        () => dispatchEvent(new CustomEvent('unsupported-browser', { detail: currentBrowser && currentBrowser?.url })
    ), 400);

    return true;
}

export { unsupportedBrowserHandler, isValidBrowser, BrowserDetector };